import { Grid } from "@scuf/common";
import CalcinaProducida from "./components/calcinaProducida";
import ConcentradoAlimentado from "./components/concentradoAlimentado";
import CorrienteEDP from "./components/corrienteEDP";
import HumedadConcentradoAlimentado from "./components/humedadConcentradoAlimentado";
import PerfilAireTostador from "./components/perfilAireTostador";
import PerfilAlimentacionTostador from "./components/perfilAlimentacionTostador";
import PerfilEnfriador1 from "./components/perfilEnfriador1";
import PerfilEnfriador2 from "./components/perfilEnfriador2";
import PerfilFrxCalcinaProducto from "./components/perfilFrxCalcinaProducto";
import PerfilFrxConcentrado from "./components/perfilFrxConcentrado";
import PerfilMinerologicoConcentradoAlimentado from "./components/perfilMineralogicoConcentradoAlimentado";
import PerfilTermocuplaInferiores from "./components/perfilTermocuplaInferiores";
import PerfilTermocuplaSuperiores from "./components/perfilTermocuplaSuperiores";
import PerfilTroneras from "./components/perfilTroneras";
import SiliceInsolublesConALim from "./components/siliceInsolublesConAlim";
import TroneraInferiorL1 from "./components/troneraInferiorL1";
import TroneraInferiorL2 from "./components/troneraInferiorL2";
import TroneraSuperiorL1 from "./components/troneraSuperiorL1";
import TroneraSuperiorL2 from "./components/troneraSuperiorL2";
import "./Tostador.css";

export default function Tostador() {
  return (
    <>
      <Grid>
        <Grid.Row className="tostador-row">
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilTermocuplaSuperiores />
          </Grid.Column>
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilTermocuplaInferiores />
          </Grid.Column>
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilAireTostador />
          </Grid.Column>
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilAlimentacionTostador />
          </Grid.Column>
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilFrxConcentrado />
          </Grid.Column>
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilFrxCalcinaProducto />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilMinerologicoConcentradoAlimentado />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilEnfriador2 />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilEnfriador1 />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <CorrienteEDP />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <PerfilTroneras />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <TroneraInferiorL1 />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <TroneraSuperiorL1 />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <TroneraInferiorL2 />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <TroneraSuperiorL2 />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <HumedadConcentradoAlimentado />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <ConcentradoAlimentado />
          </Grid.Column>

          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <SiliceInsolublesConALim />
          </Grid.Column>
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
            <CalcinaProducida />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
